<template>
    <div>
        <Header>
            <template v-slot:left>
                <img class="logo" src="@/assets/logo.png" />
            </template>
        </Header>
        <Row bg="assets/mobile/home/pos1-bg.jpg" className="pos1">
            <img src="@/assets/mobile/home/pos1-txt.png" class="pos1-txt" />
            <div class="more"><MoreBtn bg="#007aff" color="#fff" url="/m/about">MORE</MoreBtn></div>
            <img src="@/assets/pc/home/pos1/huan.png" class="huan" />
            <img src="@/assets/pc/home/pos1/ball1.png" class="ball1" />
            <img src="@/assets/pc/home/pos1/ball2.png" class="ball2" />
        </Row>
        <Row bg="assets/mobile/home/pos2-bg.jpg" className="pos2">
            <div class="more"><MoreBtn url="/service?p=pos1" :width="130">数字营销</MoreBtn></div>
        </Row>
        <Row bg="assets/mobile/home/pos3-bg.jpg" className="pos3">
            <div class="more"><MoreBtn url="/service?p=pos2" :width="130">品牌管理与传播</MoreBtn></div>
            <!-- <ul>
                <li>品牌管理<br />与咨询</li>
                <li>公关传播</li>
                <li>社会化<br />媒体传播</li>
                <li>事件营销</li>
            </ul> -->
        </Row>
        <Row bg="assets/mobile/home/pos4-bg.jpg" className="pos4">
            <div class="more"><MoreBtn url="/service?p=pos3" :width="130">智慧内容生态</MoreBtn></div>
        </Row>
        <Row bg="assets/mobile/home/pos5-bg.jpg" className="pos5">
            <div class="more"><MoreBtn url="/service?p=pos4" :width="130">文创新业态</MoreBtn></div>
        </Row>
        <Row className="pos6">
            <h1>行业洞察</h1>
            <p class="info">Industry Insights</p>
            <p class="info">洞悉行业前沿趋势 探索行业发展新机遇</p>
            <ul>
                <li v-for="item in news" :key="item.id">
                    <router-link :to="'/m/news/detail?id=' + item.id">
                        <img :src="resourceBaseUrl + item.cover + '?x-oss-process=image/resize,m_fill,w_601,h_383'" />
                        <div>{{ item.title }}</div>
                    </router-link>
                </li>
            </ul>
            <router-link to="/m/news" class="more">
                查看更多
            </router-link>
        </Row>

        <Row bg="assets/mobile/home/pos7-bg.jpg" className="pos7">
            <h1>关于浙文</h1>
            <p class="info">About Zhewen Interactive</p>
            <p class="desc">
                浙文互联成立于1993年，于2004年在上海证券交易所上市，股票代码（600986.SH）。<br />
                以技术、数据和内容创新为驱动力，以客户需求为中心，致力于为品牌提供智能营销解决方案。面对数字营销行业的新趋势，集团率先拓展影视IP打造、视频内容整合、电竞娱乐、直播电商等领域，打破营销次元，布局元宇宙虚拟资产，推动数字营销与文创产业相互融合与促进，创引产业新未来，助力谱写数字中国新篇章。
            </p>
            <img class="icon" src="@/assets/mobile/home/pos7-icon.png" />
            <div class="brand-tit">
                <h3>旗下品牌</h3>
            </div>
            <ul>
                <li>
                    <a target="_blank" href="http://www.aspiration-cn.com"><img src="@/assets/mobile/home/brand/pairui.jpg"/></a>
                </li>
                <li>
                    <a target="_blank" href="http://www.iforce-media.com/"><img src="@/assets/mobile/home/brand/iforce.jpg"/></a>
                </li>
                <li>
                    <a target="_blank" href="http://www.itrax.cn"><img src="@/assets/mobile/home/brand/itrax.jpg"/></a>
                </li>
                <li>
                    <router-link to="/m/about/tongli"><img src="@/assets/mobile/home/brand/tongli.jpg"/></router-link>
                </li>
                <li>
                    <router-link to="/m/about/huayi"><img src="@/assets/mobile/home/brand/huayi.jpg"/></router-link>
                </li>
                <li>
                    <router-link to="/m/about/ylmf"><img src="@/assets/mobile/home/brand/ylmf.jpg"/></router-link>
                </li>
                <li>
                    <a target="_blank" href="https://www.qctt.cn"><img src="@/assets/mobile/home/brand/qctt.jpg"/></a>
                </li>
                <li>
                    <router-link to="/m/about/hzzw"><img src="@/assets/mobile/home/brand/hzzw.jpg"/></router-link>
                </li>
            </ul>
        </Row>
        <Footer></Footer>
    </div>
</template>
<script>
import Header from "../../components/mobile/header.vue";
import Footer from "../../components/mobile/footer.vue";
import Row from "../../components/mobile/Row.vue";
import MoreBtn from "../../components/mobile/MoreBtn.vue";
import settings from "@/settings";
export default {
    name: "moble-home",
    components: { Header, Footer, Row, MoreBtn },
    data() {
        return {
            resourceBaseUrl: settings.resourceBaseUrl,
            news: [],
        };
    },

    mounted() {
        this.LoadNews();
    },
    methods: {
        LoadNews() {
            this.$http.get("/api/news/mobile/home").then((res) => {
                this.news = res.data;
            });
        },
    },
};
</script>
<style scoped>
@import url("../../../common/css/icon.css");
.pos7 h1 {
    font-size: 2.7rem;
    margin: 30px 0 5px 0;
}
.pos7 .info {
    font-size: 1.2rem;
    margin-bottom: 10px;
}
.pos7 .desc {
    font-size: 1.2rem;
    color: #838587;
    margin: 5% 10%;
    text-align: left;
    line-height: 2.2rem;
}
.pos7 .icon {
    width: 75%;
}
.pos7 .brand-tit {
    margin: 5% 0;
}
.pos7 .brand-tit h3 {
    font-size: 1.8rem;
    font-weight: normal;
    color: #333333;
    border-bottom: 2px #ffbd1d solid;
    display: inline-block;
    padding-bottom: 3px;
}
.pos7 ul {
    margin: 5% 5%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.pos7 ul li {
    width: 23%;
    margin: 5px 0;
}

.pos6 h1 {
    font-size: 2.7rem;
    margin: 30px 0 5px 0;
}
.pos6 .info {
    font-size: 1.2rem;
    margin-bottom: 10px;
}
.pos6 ul {
    margin: 20px 5%;
}
.pos6 ul li {
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    margin: 10px 0;
}
.pos6 ul li div {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    padding: 10px 15px;
    font-size: 1.4rem;
    background: rgba(31, 31, 31, 0.4);
    text-align: left;
}
.pos6 .more {
    display: inline-flex;
    height: 32px;
    width: 150px;
    background: #007aff;
    color: #fff;
    font-size: 1.2rem;
    border-radius: 16px;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}
.pos5 .more {
    margin-top: 51%;
}
.pos4 .more {
    margin-top: 51%;
}
.pos3 ul {
    display: flex;
    justify-content: space-between;
    margin: 13% 2%;
    height: 15%;
}
.pos3 ul li {
    flex: 1;
    background: #f8c54d;
    margin: 0 1%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
}
.pos3 .more {
    margin-top: 50%;
}
.pos2 .more {
    margin-top: 50%;
}
.pos1 {
    position: relative;
}
.pos1-txt {
    width: 75%;
    margin-top: 37%;
}
.pos1 .huan {
    position: absolute;
    left: 8%;
    right: 8%;
    top: 47%;
    width: 84%;
    animation: bounce 3s linear forwards infinite;
}
.pos1 .ball1 {
    position: absolute;
    top: 43%;
    right: 15%;
    width: 12%;
    animation: bounce-2 3s linear forwards infinite;
}

.pos1 .ball2 {
    position: absolute;
    top: 83%;
    left: 3%;
    width: 18%;
    animation: bounce-2 3s linear forwards infinite;
}
.pos1 .more {
    margin-top: 6%;
}
@keyframes hand_anim {
    100% {
        transform: translate(0, 0);
    }
}
</style>
